<template>
  <v-navigation-drawer
    :value="drawer"
    temporary
    fixed
    right
    width="360"
    class="rpd-saved-drawer"
    @input="$emit('update:drawer', $event)"
  >
    <div class="drawer__head">
      <h2>Saved queries</h2>
      <v-btn icon flat @click="$emit('update:drawer', false)">
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <div class="drawer__body">
      <v-progress-linear v-if="loading" :height="2" color="info" indeterminate />

      <!-- A store that cannot be reached is not an empty list, so the two read differently. -->
      <div v-if="unavailable" class="drawer__empty">
        <i class="material-icons" aria-hidden="true">cloud_off</i>
        <p class="drawer__empty-title">Saved queries are unavailable</p>
        <p class="drawer__empty-detail">
          The saved-query store could not be reached. Nothing has been lost — reload the page in a
          few minutes, and let us know if it keeps happening.
        </p>
      </div>

      <div v-else-if="!queries.length" class="drawer__empty">
        <i class="material-icons" aria-hidden="true">folder_open</i>
        <p class="drawer__empty-title">Nothing saved yet</p>
        <p class="drawer__empty-detail">
          Save a pairing and its criteria to reopen it later without rebuilding the filters.
        </p>
      </div>

      <ul v-else class="drawer__list">
        <li v-for="query in queries" :key="query.Id" class="drawer__item">
          <button type="button" class="drawer__item-main" @click="$emit('load:query', query.Id)">
            <span class="drawer__item-name">{{ query.Name }}</span>
            <span class="drawer__item-meta">
              <span class="chip" :class="query.IsShared ? 'chip--info' : 'chip--neutral'">
                {{ query.IsShared ? 'Shared' : 'Private' }}
              </span>
              <span class="field-note">{{ query.OwnerDisplayName || 'You' }}</span>
              <span class="field-note">{{ updatedAt(query.UpdatedAt) }}</span>
            </span>
            <span v-if="query.Description" class="drawer__item-description">{{ query.Description }}</span>
          </button>

          <v-btn
            icon
            flat
            :disabled="!query.CanDelete"
            :title="query.CanDelete ? 'Delete this query' : 'Only the owner can delete this query'"
            @click="$emit('delete:query', query)"
          >
            <v-icon>delete_outline</v-icon>
          </v-btn>
        </li>
      </ul>
    </div>
  </v-navigation-drawer>
</template>

<script>
  import MomentUtil from '@/components/mixins/MomentUtil'

  /*
   * The saved-query drawer. The `Can*` flags come from the server rather than being re-derived
   * here, so the drawer can never disagree with what the write routes will accept.
   */
  export default {
    name: 'RpdSavedQueriesDrawer',

    mixins: [MomentUtil],

    props: {
      drawer: {
        type: Boolean,
        default: false,
      },
      queries: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
      unavailable: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      updatedAt(value) {
        return value ? this.formatDate(value) : ''
      },
    },
  }
</script>
